import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { RestApiService } from '../services/restapi.service';

@Component({
    selector: 'app-text-sms-verify-dialog',
    templateUrl: './text-sms-verify-dialog.component.html',
    styleUrls: ['./text-sms-verify-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextSmsVerifyDialogComponent implements OnInit {

  confirmationCode: string = "";
  showErrorConfirmationCode: boolean = false;
  confirmationCodeErrorMessage: string = "";
  smsVerified: boolean = false;
  smsNotVerified: boolean = true;
  showExplain: boolean = true;
  enableResend: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TextSmsVerifyDialogComponent>,
    public apiService: RestApiService) { }

  verifySmsbylink(number) {
      this.showExplain = true

      const request = {
        Mobile: '+1' + number
      }
      this.enableResend = false;
      this.apiService.sendtext(request).subscribe((response: any) => {
        setTimeout(() => {
          this.enableResend = true;
        }, 5000);
      })
    }

  checkConfirmationCode(): any {
    if ( this.confirmationCode.length >= 6 ) {
      this.apiService.CheckConfirmationCode(encodeURIComponent("+1" + this.data.number), this.confirmationCode).subscribe((response: any) => {
        if ((response.Data == true) && (response.Message == "Success")) {
          this.smsNotVerified = false
          this.smsVerified = true
          this.data.service.isNOTverified_sms = true
          this.showErrorConfirmationCode = false;
          this.confirmationCodeErrorMessage = "";
          this.dialogRef.close({verified: this.smsVerified});
        } else if ((response.Data == false) && (response.Message == "Success")) {
          this.showErrorConfirmationCode = true;
          this.confirmationCodeErrorMessage = "invalid_confirmation_code";
        }
      });
    }
  }

  ngOnInit(): void {
    document.getElementsByClassName('loading-spinner')[0].classList.add('hidden')
  }

  ngOnDestroy(): void {
    this.dialogRef.close({verified: this.smsVerified});
  }
}